module.exports = __webpack_public_path__ + "static/img/qyjr46.54db639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qyjr46.png
// module id = k/yk
// module chunks = 73